import { render, staticRenderFns } from "./toolco2.vue?vue&type=template&id=638d90a0&scoped=true"
import script from "./toolco2.vue?vue&type=script&lang=js"
export * from "./toolco2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638d90a0",
  null
  
)

export default component.exports